module.exports = __webpack_public_path__ + "img/vegetable-horseradish-350x184.65063c02.jpg";